import './erro.css'

function Erro(){
    return(
        <div className="notFound">
            <h1>404</h1>
            <h2>Pagina não encontrada</h2>
            <h3>:(</h3>
        </div>
    )
}
export default Erro;